export async function getStudyReelEmail(studyReelUrl: string): Promise<string | null> {
  if (!studyReelUrl) {
    return null;
  }
  try {
    const response: Response = await fetch(`${studyReelUrl}/user`, { credentials: 'omit' });

    if (response.status === 200) {
      const data: { email: string } = await response.json();
      console.log('Retrieved email from StudyReel: ', data.email);
      return data.email;
    }

    return null;
  } catch (error) {
    console.log('Cannot get StudyReel email: ', error);
  }
}
